const personType = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  LEGAL_PERSON: 'LEGAL_PERSON'
};

module.exports = personType;
